export enum ApiPaths {
  FILE_UPLOAD = 'file',
}
